import React, { useContext } from 'react';
import Alert from '@meridian/components/alert';
import Column from '@meridian/components/column';

import { GlobalStateContext } from '../../global/context/GlobalStateContext';

const ErrorPage = ({ errorTitle, errorMessage }) => {
  const { restartApp } = useContext(GlobalStateContext);
  return (
    <Column spacingInset="400">
      <Alert type="error" size="large" width="100%" title={errorTitle} onClose={restartApp}>
        {errorMessage.toString()}
      </Alert>
    </Column>
  );
};

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/components/handler/errorHandler/ErrorPage.js